<template>
  <b-card class="form-builder-card" title="  در این قسمت می توانید محتوای گالری مورد نظر را اضافه کنید">
    <b-row class="mt-1">

      <!--title-->
      <b-col cols="6">
        <!-- category name-->
        <b-form-group
            label="عنوان محتوا (اجباری)"
            label-for="v-content-title"
        >
          <b-form-input
              id="v-content-title"
              placeholder="عنوان محتوا را وارد کنید"
              v-model="postData.title"
          />
        </b-form-group>

      </b-col>
      <!--category-->
      <b-col cols="6">
        <!-- category name-->

        <b-form-group
            label="انتخاب دسته محتوا (اجباری)"
            label-for="mother-categories"
        >
          <b-form-select
              id="mother-categories"
              v-model="postData.categoryID"
              :options="categories"

          />
        </b-form-group>
      </b-col>
      <!--short , long desc-->
      <b-col cols="6">
        <div class=" mb-2">
          <b-form-group
              label="توضیحات کوتاه"
          >
            <b-form-textarea
                placeholder="در این قسمت می توانید توضیحات کوتاه گالری خود را انتخاب کنید"
                rows="4"
                v-model="postData.shortDescription"
            />
          </b-form-group>


          <b-form-group
              label="توضیحات اصلی"
          >
            <b-form-textarea
                placeholder="در این قسمت می توانید توضیحات اصلی گالری خود را انتخاب کنید"
                rows="6"
                v-model="postData.longDescription"

            />
          </b-form-group>
        </div>
      </b-col>
      <!--expert , price , discount -->
      <b-col cols="6">

        <div>
          <b-form-group
              label="نام کارشناس"
              label-for="v-content-title"
          >
            <b-form-input
                placeholder="عنوان محتوا را وارد کنید"
                v-model="postData.expert"
            />
          </b-form-group>
          <b-form-group
              label="توضیحات در مورد کارشناس"
          >
            <b-form-textarea
                placeholder="در این قسمت می توانید توضیحات در مورد کارشناس  را انتخاب کنید"
                rows="4"
                v-model="postData.expertIntroduction"
            />
          </b-form-group>

          <b-form-group
              label="قیمت (تومان)"
              description="اگر فیلد قیمت را خالی بگذارید محتوا به صورت رایگان در دسترس است"
          >
            <b-form-input
                type="number"
                placeholder="در این قسمت می توانید قیمت محتوا گالری را وارد کنید"
                v-model="postData.price"


            ></b-form-input>
          </b-form-group>


          <b-form-group
              label="درصد تخفیف"
              description="اگر فیلد درصد را خالی بگذارید محتوا به قیمت اصلی به فروش گذاشته می شود"
              v-show="postData.price !== 0"
          >
            <b-form-input
                type="number"
                placeholder="در این قسمت می توانید درصد تخفیف محتوا گالری را وارد کنید"
                v-model="postData.discountPercent"

            ></b-form-input>
          </b-form-group>


        </div>

      </b-col>
      <!--cover image -->
      <b-col cols="12" class="mb-2">
        <b-form-group
            label="آپلود کاور گالری"

        >
          <b-form-file

              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              accept=".jpg,.svg, .png"
              @change="handleCoverImageUpload( $event )"
          />

        </b-form-group>


        <div class="image-preview">
          <b-img :src="previewCoverImage" v-show="showPreviewCoverImage" fluid/>
        </div>

      </b-col>

      <b-col cols="12" class="mt-4">

        <!--dropdown-->
        <b-dropdown
            text="نوع محتوای گالری را مشخص کنید"
            variant="gradient-success"
        >
          <b-dropdown-item v-for="item of contentTypes" v-bind:key="item.id" @click="addSection(item.id)">
            {{ item.type }}
          </b-dropdown-item>

          <b-dropdown-divider/>
        </b-dropdown>


        <image-gallery-form @imageChanged="imageChanged" v-if="id===1"></image-gallery-form>
        <voice-gallery-form @voiceChanged="voiceChanged" v-if="id===2"></voice-gallery-form>
        <video-gallery-form  @videoChanged="videoChanged" v-if="id===3"></video-gallery-form>


      </b-col>
    </b-row>

    <b-row class="mt-1" v-if="voiceFile || imageFile || videoFile" >
      <b-col md="3">
        <div class="demo-inline-spacing">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              variant="success"
              @click="addContent"
          >
            ذخیره محتوا گالری
          </b-button>
        </div>
      </b-col>
    </b-row>

  </b-card>

</template>

<script>

import {
  BListGroupItem, BFormGroup, BButton, BFormTextarea
  , BAvatar, BFormSelect, BFormFile, BImg, BFormInput, BRow, BCol, BDropdown, BDropdownItem, BDropdownDivider, BCard
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Swal from "sweetalert2";
import contentRepository from "@/modules/contents/services/contentRepository";
import ImageGalleryForm from "@/modules/gallery/components/ImageGalleryForm";
import VoiceGalleryForm from "@/modules/gallery/components/VoiceGalleryForm";
import VideoGalleryForm from "@/modules/gallery/components/videoGalleryForm";
import categoryRepository from "@/modules/categories/services/categoryRepository";
import galleryRepository from "@/modules/gallery/services/galleryRepository";
import uploadService from "@/modules/services/uploadService";
import router from '@/router'

export default {
  name: "contentBuilder",
  components: {
    BRow,
    BFormFile,
    BCol,
    BCard,
    BImg,
    BFormGroup,
    BButton, draggable,
    BListGroupItem,
    BAvatar,
    Prism,
    BDropdown,
    BFormTextarea,
    BFormSelect, BFormInput,
    BDropdownDivider,
    BDropdownItem,
    ImageGalleryForm,
    VoiceGalleryForm,
    VideoGalleryForm,
  },
  data() {
    return {
      imageFile:undefined,
      voiceFile:undefined,
      videoFile:undefined,
      categories: [],
      selectedCategory: null,
      CoverImageFile: undefined,
      previewCoverImage: undefined,
      showPreviewCoverImage: false,
      title: undefined,
      id: undefined,
      list: [],
      contentTypes: [
        {
          type: 'عکس',
          id: 1,
        },
        {
          type: 'ویس',
          id: 2,
        },
        {
          type: 'ویدیو',
          id: 3,
        }
      ],
      icons: {
        0: "TypeIcon",
        1: "MusicIcon",
        2: "YoutubeIcon",
      },
      postData:{
        categoryID: this.selectedCategory,
        title: this.title,
        shortDescription: "",
        longDescription: "",
        expertIntroduction: "",
        price: 0,
        discountPercent: 0,
        thumbnail: '',
        photo: "",
        mediaIDs: [

        ],
        status:true,
        expert: "",
        type: 0
      }
    }
  },
  created() {
    this.getCategories();
  },
  methods: {
    handleCoverImageUpload(event) {
      this.CoverImageFile = event.target.files[0]
      console.log('handleCoverImageUpload')
      let reader = new FileReader();

      reader.addEventListener("load", function () {
        console.log('load')
        console.log(reader.result, 'result')

        this.showPreviewCoverImage = true;
        this.previewCoverImage = reader.result;
      }.bind(this), false);

      if (this.CoverImageFile) {
        /*
          Ensure the file is an image file.
        */
        console.log(this.CoverImageFile, 'CoverImageFile')

        if (/\.(jpe?g|png)$/i.test(this.CoverImageFile.name)) {

          /*
            Fire the readAsDataURL method which will read the file in and
            upon completion fire a 'load' event which we will listen to and
            display the image in the preview.
          */
          console.log('reader')

          reader.readAsDataURL(this.CoverImageFile);
        }
      }

    },
    async addContent() {
      await Swal.showLoading()

      if (this.postData.price && this.postData.price < 0) {
        await Swal.fire('خطا', 'لطفا قیمت منفی وارد نکنید', 'error')
      }else  {
        if (this.postData.categoryID && this.postData.title) {




          // let mediaId = '';
          let fileAddress = '';

          console.log(this.voiceFile)
          console.log(this.videoFile)
          console.log(this.imageFile)



          if (this.voiceFile){
            console.log('this.voiceFile ')
            fileAddress = await uploadService.upload(this.voiceFile);
            this.postData.type = 2
            let array = fileAddress.split('/');
            let mediaId = array[array.length - 1].split('.')[0];
            this.postData.mediaIDs.push(mediaId);

          }else if(this.imageFile){
            console.log('this.imageFile ')
            fileAddress = await uploadService.upload(this.imageFile);
            console.log(fileAddress);
            // mediaId = this.getMediaId(fileAddress)
            this.postData.type = 1
            let array = fileAddress.split('/');
            let mediaId = array[array.length - 1].split('.')[0];
            this.postData.mediaIDs.push(mediaId);

            // this.postData.mediaIDs.push(this.getMediaId());
          }else if (this.videoFile) {
            console.log('this.videoFile ')
            fileAddress = await uploadService.upload(this.videoFile);
            this.postData.type = 3

            let array = fileAddress.split('/');
            let mediaId = array[array.length - 1].split('.')[0];
            this.postData.mediaIDs.push(mediaId);

          }




          if (this.CoverImageFile){
            let imageAddress= await uploadService.upload(this.CoverImageFile);
            this.postData.photo = imageAddress;
            this.postData.thumbnail = imageAddress;
          }
          // if (fileAddress){
          //   this.postData.mediaIDs.push(fileAddress);
          // }


          console.log(this.postData , 'postData')

          const {data} = await galleryRepository.create(this.postData);

          if (data.isSuccess) {
            await Swal.close();
            await Swal.fire({
              confirmButtonText: 'ok',
              title: 'موفقیت',
              html: 'عملیات با موفقیت انجام شد',
              icon: 'success'
            });
             // this.$router.replace('/gallery/list')
           // await router.push('/gallery/list')

            this.gotolist()

          } else {
            await Swal.fire('هشدار', data.message, 'warning');
          }
        } else {
          await Swal.fire('هشدار', 'لطفا مقادیر  دسته و عنوان را وارد کنید', 'warning')
        }
      }
    },
    gotolist(){
      router.push('/gallery/list')
    },
    async getCategories() {
      const {data} = await categoryRepository.get({type: 2});
      if (data.isSuccess) {
        let cats = data.data.data.map(p => {
          return {
            value: p.id, text: p.title
          }
        });
        cats.forEach(p => {
          this.categories.push(p);
        })
      }
    },
    getMediaId(fileAddress){
      let filename = fileAddress.split('/')[1];
       return  filename.split('.').slice(0,-1).join('.');
    },
    addSection(id) {
      if (this.id !== id  ){
        this.id = id;
        this.imageFile = undefined;
        this.voiceFile = undefined;
        this.videoFile = undefined;
      }
    },
    removeItem(index) {
      this.list.splice(index, 1)
    },
    voiceChanged(value){
      console.log(value);
      this.voiceFile = value;
    },
    videoChanged(value){
      console.log(value);
      this.videoFile = value;

    },
    imageChanged(value){
      console.log(value);
      this.imageFile = value;

    }


  }
}
</script>

<style lang="scss" scoped>
.list-group-item {
  transition: all 1s
}

.ck-editor__editable {
  height: 400px !important;
}

.form-builder-card {
  min-height: 500px;
}

.image-preview {
  max-width: 300px;
  max-height: 150px;
  alignment: center;
  margin-bottom: 3rem;
}
</style>
